import * as React from 'react'
import { CodeBlock } from '../../../ui/codeBlock'

interface Props {
    message?: {
        args: {
            causes: string[]
        }
    }
}

const code = `use Doctrine\\Common\\Annotations\\AnnotationReader;
use Doctrine\\Common\\Annotations\\PsrCachedReader;

$cache = createPsr6CachePool(); // instantiate a PSR-6 Cache pool

$reader = new PsrCachedReader(new AnnotationReader(), $cache, $debug = true);
`

export default class TokenGetAll extends React.PureComponent<Props> {
    render = () => {
        const causes = this.props.message?.args.causes || []

        return (
            <div>
                <p>
                    When using <code>token_get_all</code> in a web request it is often slow and because the PHP code does not change between
                    deployments, you should cache this call and the information that you are retrieving.
                </p>

                <p>If this happens from within a library, they probably have some way of caching that you are not using yet.</p>

                {causes ? (
                    <p>
                        The following known problems calling <code>token_get_all</code> were found:
                    </p>
                ) : null}

                <ol>
                    {causes.indexOf('phpDocumentor\\Reflection\\Types\\ContextFactory::createForNamespace') >= 0 ? (
                        <li>
                            <p>
                                Using phpDocumentor in a web request is highly discouraged. It is slow and should be cached.
                                <code>ContextFactory::createForNamespace</code> parses a whole file for docblocks.
                            </p>

                            <p>
                                This might happen when you use API Platform: In this case ensure that metadata caching is active and
                                configured (<a href="https://api-platform.com/docs/core/performance/">Details</a>).
                            </p>

                            <p>
                                Check for <code>token_get_all</code> getting called from <code>ContextFactory::createForNamespace</code>
                                to detect that API Platform caching is not working.
                            </p>
                        </li>
                    ) : null}
                    {causes.indexOf('Doctrine\\Common\\Annotations\\TokenParer::__construct') >= 0 ? (
                        <li>
                            <p>When you use doctrine/annotations, wrap the annotation reader in a cached reader like this:</p>

                            <CodeBlock language="php" code={code} />
                        </li>
                    ) : null}
                    <li>
                        <p>
                            When <code>token_get_all</code> is called from <code>AttributeFileLoader::findClass</code> then you are using
                            Symfony routing without caching or directly call <code>Router::getRouteCollection</code>, which is not
                            recommended in production code.
                        </p>
                    </li>
                </ol>
            </div>
        )
    }
}
